import { useState } from 'react'
import { Stack, TextField } from '@fluentui/react'
import Send from '../../assets/Send.svg'
import SendDisabled from '../../assets/SendDisabled.svg'
import { mergeStyles } from '@fluentui/react/lib/Styling';
import styles from './QuestionInput.module.css'
import { ChatMessage } from '../../api'

const CustomPlaceholder = mergeStyles({
  backgroundColor: '#001E60',
  color: 'white',
  borderRadius: '15px',
  fontWeight: 'bold',
 ':hover': {
  borderRadius: '15px',
    },
});


interface Props {
  onSend: (question: ChatMessage['content'], id?: string) => void
  disabled: boolean
  placeholder?: string
  clearOnSend?: boolean
  conversationId?: string
}
const MAX_CHARACTER_COUNT = 300;
export const QuestionInput = ({ onSend, disabled, placeholder, clearOnSend, conversationId }: Props) => {
  const [question, setQuestion] = useState<string>('')
  const sendQuestion = () => {
    if (disabled || !question.trim()) {
      return
    }

    const questionTest: ChatMessage["content"] = question.toString();

    if (conversationId && questionTest !== undefined) {
      onSend(questionTest, conversationId)
    } else {
      onSend(questionTest)
    }

    if (clearOnSend) {
      setQuestion('')
    }
  }

  const onEnterPress = (ev: React.KeyboardEvent<Element>) => {
    if (ev.key === 'Enter' && !ev.shiftKey && !(ev.nativeEvent?.isComposing === true)) {
      ev.preventDefault()
      sendQuestion()
    }
  }

  const onQuestionChange = (_ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
    setQuestion(newValue?.slice(0, MAX_CHARACTER_COUNT) || '')
  }

  const sendQuestionDisabled = disabled || !question.trim()

  return (
    <Stack horizontal className={styles.questionInputContainer} style={{left: 1,  height: '130px'}} >
      <TextField
        className={ styles.questionInputTextArea }
        placeholder={placeholder}
        multiline
        resizable={false}
        borderless
        value={question}
        onChange={onQuestionChange}
        onKeyDown={onEnterPress}
        style={{height: '100px' , fontStyle: sendQuestionDisabled? 'italic': 'normal', color: sendQuestionDisabled? '#343434': '#000000', fontFamily: " 'AvenirNextWorld-Regular', Arial, Helvetica, sans-serif" }}
      />
      <div
        className={styles.questionInputSendButtonContainer}
        role="button"
        tabIndex={0}
        aria-label="Ask question button"
        onClick={sendQuestion}
        onKeyDown={e => (e.key === 'Enter' || e.key === ' ' ? sendQuestion() : null)}>
           {sendQuestionDisabled ?  <img src={SendDisabled} className={styles.questionInputSendButton} alt="Send Button" /> :
        <img src={Send} className={styles.questionInputSendButton} alt="Send Button" /> }
      </div>
    </Stack>
  )
}
